export default __webpack_public_path__ + "0daa9a06a6457d6e09089e416424f7f1.svg";